import { getCart, getCartTotal, getStoreCartTotal } from '@helpers/cart'
import { getOrder } from '../global'
import { getRemainingTotal } from './payment-section'

export const onlyNumbers = value => {
  if (value) {
    return value
      .toString()
      .trim()
      .replace(/\$/g, '') // replace all $
      .replace(/,/g, '') // remove all commas/extra char for Apple Pay
  }
  return value
}

export const applePaySupported = () =>
  typeof window !== 'undefined' &&
  window.location.protocol === 'https:' &&
  window.ApplePaySession &&
  window.ApplePaySession.canMakePayments()

export const applePayEnabled = async () => {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && window.ApplePaySession) {
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(process.env.GATSBY_APPLE_MERCHANT_IDENTIFIER)
    return promise.then(canMakePayments => canMakePayments)
  }
  return false
}

export const getApplePayEmail = order => {
  if (order && order.paymentInfo) {
    const pp = order.paymentInfo.filter(payment => payment.paymentType === 'APP')[0]
    if (pp && pp.paymentProperties && pp.paymentProperties.payerEmail) {
      return pp.paymentProperties.payerEmail
    }
  }
  return ''
}

export const getApplePayTotal = total => {
  const order = getOrder()
  let apTotal = order.total
  if (order && order.orderId && (total > 0 || order.total > 0)) {
    const applyFinance =
      order &&
      order.paymentInfo &&
      order.paymentInfo.filter(
        payment =>
          payment.paymentType === 'FIN' ||
          (payment.paymentType === 'DBUY' && payment.paymentProperties && payment.paymentProperties.hasPayments),
      ).length > 0
    apTotal = Math.floor((getRemainingTotal(true, null, true, applyFinance).total || total) * 100) / 100
  }
  return apTotal
}

export const generateShippingAddressLineTwo = ({ shippingAddress, billingAddress }) => {
  let addressLineTwo = ''
  if (shippingAddress && shippingAddress.address_line_2) {
    addressLineTwo = shippingAddress.address_line_2
  } else if (billingAddress && billingAddress.address_line_2) {
    addressLineTwo = billingAddress.address_line_2
  }
  return addressLineTwo
}

export const getApplePayCartTotal = () => {
  const cart = getCart()
  const order = getOrder()
  let cartTotal = getCartTotal(cart)
  if (order && order.lineItems) {
    const storeCartLineItems = order.lineItems.filter(lineItem => lineItem.isStoreSku)
    if (storeCartLineItems.length > 0) {
      cartTotal += getStoreCartTotal(storeCartLineItems)
    }
  }
  cartTotal = Math.floor(cartTotal * 100) / 100
  return cartTotal
}

export const scrollTo = element => {
  setTimeout(() => {
    if (document.getElementById(element)) {
      document.getElementById(element).scrollIntoView({
        behavior: 'smooth',
      })
    }
  }, 1000)
}

export const triggerEvent = (el, type) => {
  if ('createEvent' in document) {
    // modern browsers, IE9+
    const e = document.createEvent('HTMLEvents')
    e.initEvent(type, false, true)
    el.dispatchEvent(e)
  } else {
    // IE8-, etc
    const e = document.createEventObject()
    e.eventType = type
    el.fireEvent(`on${e.eventType}`, e)
  }
}

// Cart V2 specific helper functions
export const getApplePayTotalV2 = (cartV2Data, total) => {
  if (!cartV2Data) {
    return getApplePayTotal(total)
  }

  // For cart v2, we use the cartTotal directly since it already includes all calculations
  let apTotal = cartV2Data?.cartTotal ?? 0

  // If we have an order with payment info, we need to consider existing payments
  const order = getOrder()
  if (order && order.orderId && order.paymentInfo && order.paymentInfo.length > 0) {
    const applyFinance = order.paymentInfo.some(
      payment =>
        payment.paymentType === 'FIN' ||
        (payment.paymentType === 'DBUY' && payment.paymentProperties && payment.paymentProperties.hasPayments),
    )

    if (applyFinance) {
      // Use the remaining total calculation for financed orders
      apTotal = Math.floor((getRemainingTotal(true, null, true, true).total || apTotal) * 100) / 100
    }
  }

  return apTotal
}

export const getApplePayCartTotalV2 = cartV2Data => {
  if (!cartV2Data) {
    return getApplePayCartTotal()
  }

  // For cart v2, the cartTotal already includes all items and calculations
  return cartV2Data?.cartTotal ?? 0
}
